import React, { useState } from 'react';
import AddUser from './AddUser';
import UserList from './UserList'

import Paper from '@mui/material/Paper';

import './Home.css';

const Home = () => {

	const [userList, setUserList] = useState([]);

	function newUser(user) {
		setUserList([...userList, user]);
	}

	function removeUser(index) {

		let filteredList = userList.filter(el => el != userList[index]);
		setUserList(filteredList);

	}

	return (
		<>
		<Paper elevation={12}>
			
			<AddUser addNewUser={newUser} />

		</Paper>

		<Paper sx={{ mt: 4 }} elevation={12}>
	
			<UserList ul={userList} removeU={removeUser} />

	    </Paper>
		</>
	)
}

export default Home